import * as React from 'react';

import { statusIconClass } from '~src/app/content/RemoteAgentPresenceIcon';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { IRemoteQueryAgent, RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

import { getAgentStatus } from '../BridgeRemoteAgentsSection/BridgeRemoteAgentsPresenceIcon';
import { UserDefinedPoolModel } from '../types/PoolModel';

export type PoolStatusIconProps = Readonly<{
  pool: UserDefinedPoolModel;
  connectionStatuses: IRemoteAgentConnectionStatus[];
}>;

export function PoolStatusIcon(props: PoolStatusIconProps) {
  const {pool, connectionStatuses} = props;
  let statusImage: string;
  let statusMessage: string;
  const agents: IRemoteQueryAgent[] = Object.values(pool.agents);

  if (agents.length === 0) {
    statusImage = 'status_error_18px-large.svg';
    statusMessage = Messages.bridgeSiteSettingsPoolStatusError();
  } else if (hasActiveAgents(agents, connectionStatuses)) {
    statusImage = 'status_active_18px-large.svg';
    statusMessage = Messages.bridgeSiteSettingsPoolStatusReady();
  } else {
    statusImage = 'status_down_18px-large.svg';
    statusMessage = Messages.bridgeSiteSettingsPoolStatusDown();
  }

  return renderStatusIcon(statusImage, statusMessage);
}

function renderStatusIcon(statusImage: string, statusMessage: string) {
  return <>
    <img src={imgPath(statusImage)} alt={''} className={statusIconClass} />
    <span>{statusMessage}</span>
  </>;
}

function hasActiveAgents(agents: IRemoteQueryAgent[], connectionStatuses: IRemoteAgentConnectionStatus[]) {
  if (agents.some(agent =>
    getAgentStatus(agent, connectionStatuses)?.connectionStatus === RemoteAgentConnectionStatus.CONNECTED)) {
    return true;
  }
  return false;
}
